export default "__VITE_ASSET__DM$MGA0i__"